import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  /** Scroll behavior: 'auto' for instant, 'smooth' for animated */
  behavior?: ScrollBehavior;
}

/**
 * Scrolls to top of page on route change.
 * Respects reduced motion preference by using 'auto' behavior when enabled.
 */
export function ScrollToTop({ behavior = 'auto' }: ScrollToTopProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefersReducedMotion ? 'auto' : behavior,
    });
  }, [pathname, behavior]);

  return null;
}

export default ScrollToTop;
